import { Entity } from '@data-client/rest';
import { ISODate } from '../utils/transforms';
class UserAliasEntity extends Entity {
    constructor() {
        super(...arguments);
        this.aliasEmailAddress = '';
        this.confirmationSentDDTM = null;
        this.creationByUserId = '';
        this.createdDTTM = new Date();
        this.deletedByUserId = null;
        this.isConfirmed = false;
        this.isDeleted = false;
        this.updateByUserId = null;
        this.updatedDTTM = null;
        this.userAliasId = 0;
        this.userId = '';
    }
    pk() {
        return this.userAliasId.toString();
    }
}
UserAliasEntity.schema = {
    confirmationSentDDTM: ISODate,
    countDate: ISODate,
    updatedDTTM: ISODate
};
UserAliasEntity.key = 'UserAlias';
export { UserAliasEntity };
